var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Bean, ComponentUtil, Grid } from 'ag-grid-community';
import { VueFrameworkComponentWrapper } from './VueFrameworkComponentWrapper';
import { getAgGridProperties } from './Utils';
import { AgGridColumn } from './AgGridColumn';
var _a = getAgGridProperties(), props = _a[0], watch = _a[1], model = _a[2];
var AgGridVue = /** @class */ (function (_super) {
    __extends(AgGridVue, _super);
    function AgGridVue() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.gridCreated = false;
        _this.isDestroyed = false;
        _this.gridReadyFired = false;
        _this.emitRowModel = null;
        return _this;
    }
    AgGridVue_1 = AgGridVue;
    AgGridVue.kebabProperty = function (property) {
        return property.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    };
    // noinspection JSUnusedGlobalSymbols, JSMethodCanBeStatic
    AgGridVue.prototype.render = function (h) {
        return h('div');
    };
    AgGridVue.prototype.globalEventListener = function (eventType, event) {
        if (this.isDestroyed) {
            return;
        }
        if (eventType === 'gridReady') {
            this.gridReadyFired = true;
        }
        this.updateModelIfUsed(eventType);
        // only emit if someone is listening
        // we allow both kebab and camelCase event listeners, so check for both
        var kebabName = AgGridVue_1.kebabProperty(eventType);
        if (this.$listeners[kebabName]) {
            this.$emit(kebabName, event);
        }
        else if (this.$listeners[eventType]) {
            this.$emit(eventType, event);
        }
    };
    AgGridVue.prototype.processChanges = function (propertyName, currentValue, previousValue) {
        if (this.gridCreated) {
            if (this.skipChange(propertyName, currentValue, previousValue)) {
                return;
            }
            var changes = {};
            changes[propertyName] = {
                currentValue: currentValue,
                previousValue: previousValue,
            };
            ComponentUtil.processOnChange(changes, this.gridOptions, this.gridOptions.api, this.gridOptions.columnApi);
        }
    };
    // noinspection JSUnusedGlobalSymbols
    AgGridVue.prototype.mounted = function () {
        var _this = this;
        // we debounce the model update to prevent a flood of updates in the event there are many individual
        // cell/row updates
        this.emitRowModel = this.debounce(function () {
            _this.$emit('data-model-changed', Object.freeze(_this.getRowData()));
        }, 20);
        var frameworkComponentWrapper = new VueFrameworkComponentWrapper(this);
        var gridOptions = ComponentUtil.copyAttributesToGridOptions(this.gridOptions, this);
        this.checkForBindingConflicts();
        gridOptions.rowData = this.getRowDataBasedOnBindings();
        if (AgGridColumn.hasChildColumns(this.$slots)) {
            gridOptions.columnDefs = AgGridColumn.mapChildColumnDefs(this.$slots);
        }
        var gridParams = {
            globalEventListener: this.globalEventListener.bind(this),
            providedBeanInstances: {
                frameworkComponentWrapper: frameworkComponentWrapper,
            },
            modules: this.modules,
        };
        new Grid(this.$el, gridOptions, gridParams);
        this.gridCreated = true;
    };
    // noinspection JSUnusedGlobalSymbols
    AgGridVue.prototype.destroyed = function () {
        if (this.gridCreated) {
            if (this.gridOptions.api) {
                this.gridOptions.api.destroy();
            }
            this.isDestroyed = true;
        }
    };
    AgGridVue.prototype.checkForBindingConflicts = function () {
        var thisAsAny = this;
        if ((thisAsAny.rowData || this.gridOptions.rowData) &&
            thisAsAny.rowDataModel) {
            console.warn('ag-grid: Using both rowData and rowDataModel. rowData will be ignored.');
        }
    };
    AgGridVue.prototype.getRowData = function () {
        var rowData = [];
        this.gridOptions.api.forEachNode(function (rowNode) {
            rowData.push(rowNode.data);
        });
        return rowData;
    };
    AgGridVue.prototype.updateModelIfUsed = function (eventType) {
        if (this.gridReadyFired &&
            this.$listeners['data-model-changed'] &&
            AgGridVue_1.ROW_DATA_EVENTS.indexOf(eventType) !== -1) {
            if (this.emitRowModel) {
                this.emitRowModel();
            }
        }
    };
    AgGridVue.prototype.getRowDataBasedOnBindings = function () {
        var thisAsAny = this;
        var rowDataModel = thisAsAny.rowDataModel;
        return rowDataModel ? rowDataModel :
            thisAsAny.rowData ? thisAsAny.rowData : thisAsAny.gridOptions.rowData;
    };
    /*
     * Prevents an infinite loop when using v-model for the rowData
     */
    AgGridVue.prototype.skipChange = function (propertyName, currentValue, previousValue) {
        if (this.gridReadyFired &&
            propertyName === 'rowData' &&
            this.$listeners['data-model-changed']) {
            if (currentValue === previousValue) {
                return true;
            }
            if (currentValue && previousValue) {
                var currentRowData = currentValue;
                var previousRowData = previousValue;
                if (currentRowData.length === previousRowData.length) {
                    for (var i = 0; i < currentRowData.length; i++) {
                        if (currentRowData[i] !== previousRowData[i]) {
                            return false;
                        }
                    }
                    return true;
                }
            }
        }
        return false;
    };
    AgGridVue.prototype.debounce = function (func, delay) {
        var timeout;
        return function () {
            var later = function () {
                func();
            };
            window.clearTimeout(timeout);
            timeout = window.setTimeout(later, delay);
        };
    };
    var AgGridVue_1;
    AgGridVue.ROW_DATA_EVENTS = ['rowDataChanged', 'rowDataUpdated', 'cellValueChanged', 'rowValueChanged'];
    __decorate([
        Prop(Boolean)
    ], AgGridVue.prototype, "autoParamsRefresh", void 0);
    __decorate([
        Prop({ default: function () { return []; } })
    ], AgGridVue.prototype, "componentDependencies", void 0);
    __decorate([
        Prop({ default: function () { return []; } })
    ], AgGridVue.prototype, "modules", void 0);
    AgGridVue = AgGridVue_1 = __decorate([
        Bean('agGridVue'),
        Component({
            props: props,
            watch: watch,
            model: model,
        })
    ], AgGridVue);
    return AgGridVue;
}(Vue));
export { AgGridVue };



//////////////////
// WEBPACK FOOTER
// ./~/ag-grid-vue/lib/AgGridVue.js
// module id = 657
// module chunks = 1